import * as actions from "Actions";
import * as api from "Api";

export const fetchEmailTextModels = lng => {
  return (dispatch, getState) => {
    return dispatch(actions.getEmailTextModels(api.getEmailTextModels(lng)));
  };
};

export const fetchPresentationEmailHistory = (targetUen, year) => {
  return (dispatch, getState) => {
    const { uen } = getState().auth.currentOrganization;
    return dispatch(
      actions.getPresentationEmailHistory(
        api.getPresentationEmailHistory(targetUen, uen, year)
      )
    );
  };
};

export const savePresentationEmailHistory = (
  target,
  recipient,
  modelCode,
  year
) => {
  return (dispatch, getState) => {
    const { uen } = getState().auth.currentOrganization;
    return dispatch(
      actions.savePresentationEmailHistory(
        api.savePresentationEmailHistory(
          uen,
          target,
          recipient,
          modelCode,
          year
        )
      )
    );
  };
};

export const fetchEmailRecipients = uen => {
  return (dispatch, getState) => {
    return dispatch(actions.getEmailRecipients(api.getEmailRecipients(uen)));
  };
};

export const sendPresentationEmail = (
  recipients,
  type,
  lng,
  dynamicFields,
  files
) => {
  return (dispatch, getState) => {
    const {
      auth: { currentOrganization }
    } = getState();
    return dispatch(
      actions.sendPresentationEmail(
        api.sendPresentationEmail(
          recipients,
          type,
          lng,
          dynamicFields,
          currentOrganization.id,
          files
        )
      )
    );
  };
};



// WEBPACK FOOTER //
// ./src/actions/thunks/emailing.js